var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs';
import Theme from 'Theme';
import { t } from 'helpers/i18n';
import ToggleSelect from './ToggleSelect';
var FieldToggleSelect = /** @class */ (function (_super) {
    __extends(FieldToggleSelect, _super);
    function FieldToggleSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (event) {
            console.log('event.target.options', event.target.options);
            var select = event.target;
            var values = [].filter.call(select.options, function (o) { return o.selected; }).map(function (o) { return o.value; });
            // console.log('values', values)
            if (_this.props.multiple) {
                _this.props.onChange(_this.props.name, values, _this.props.column);
            }
            else {
                var value = event.target.options.find(function (o) { return o.selected === true; });
                if (value) {
                    _this.props.onChange(_this.props.name, value.value || null, _this.props.column);
                }
            }
        };
        return _this;
    }
    FieldToggleSelect.prototype.render = function () {
        var _a = this.props, name = _a.name, required = _a.required, onChange = _a.onChange, id = _a.id, tooltipContent = _a.tooltipContent, onError = _a.onError, options = _a.options, props = __rest(_a, ["name", "required", "onChange", "id", "tooltipContent", "onError", "options"]);
        return (React.createElement(ToggleSelect, { id: id, multiple: props.multiple, tooltipContent: tooltipContent, label: t(name) + (required ? '*' : ''), className: className, onChange: this.handleChange, onError: onError, options: options }));
    };
    return FieldToggleSelect;
}(Component));
export default FieldToggleSelect;
var className = cxs({
    margin: Theme.size.space[1]
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldToggleSelect.tsx
// module id = 960
// module chunks = 0